module.exports = __webpack_public_path__ + "static/img/2.5.7ad1013.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/picture/2.5.jpg
// module id = wmtO
// module chunks = 7